import { Platform } from 'react-native';

import { ANDROID_USER_AGENT } from '@sg/shared-utils';

import { getAppName, getEnvVars } from './common';

/**
 * Returns fetch options that can be used with any GraphQL request.
 */
export function getFetchOptions(params?: GetFetchOptionsParams): RequestInit {
  const { extraHeaders } = params ?? {};

  return {
    credentials: 'include',
    headers: {
      ...getClientIDHeaders(),
      ...extraHeaders,
    },
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getClientIDHeaders(): Headers {
  return {
    'apollographql-client-name': APP_NAME,
    'apollographql-client-version': APP_VERSION_GQL_CLIENT,
    ...getCustomUserAgent(),
  };
}

function getCustomUserAgent() {
  return Platform.select({
    android: { 'User-Agent': ANDROID_USER_AGENT },
    default: {},
  });
}

// ─── Constants ───────────────────────────────────────────────────────────────

const { APP_VERSION_GQL_CLIENT = '0.0.1' } = getEnvVars();
const APP_NAME = getAppName();

// ─── Types ───────────────────────────────────────────────────────────────────

type GetFetchOptionsParams = {
  extraHeaders?: RequestInit['headers'];
};

type Headers = Readonly<{
  'apollographql-client-name': string;
  'apollographql-client-version': string;
}>;
